module.exports = __webpack_public_path__ + "media/img/scholarship_types/Scholarships For Women-a33cce8d57c666f68bc2e49d6f3854ce.svg";